'use client';

import { useTermsAndPolicy } from './_hooks/use-terms-and-policy.hook';

import { Markdown } from '@/components/ui/markdown/markdown.component';

export const PrivacyPolicyContent = () => {
  const { policy, isLoading } = useTermsAndPolicy();

  if (isLoading || !policy) {
    return (
      <div className="w-full flex justify-center py-4">
        <div className="flex flex-row gap-2">
          <div className="h-2 w-2 bg-green-300 rounded-full animate-bounce-lg [animation-delay:-0.3s]"></div>
          <div className="h-2 w-2 bg-green-300 rounded-full animate-bounce-lg [animation-delay:-0.15s]"></div>
          <div className="h-2 w-2 bg-green-300 rounded-full animate-bounce-lg"></div>
        </div>
      </div>
    );
  }

  return <Markdown content={policy} />;
};
